<template>
  <div id="about">
    <header>
      <a
        @click="closeAbout"
        class="back">
        <b-icon size="is-large" icon="arrow-left" type=""></b-icon>
      </a>
      <img class="logo" :src="logo" />
    </header>
    <about-md class="content"></about-md>
  </div>
</template>

<script>

import logo from '../kappazeta_logo.svg'
import DefaultAbout from 'conf/docs/default_about.md'

export default {
  components: {
    'about-md': () => ({
      component: import(`conf/docs/${window.app.id}_about.md`),
      error: DefaultAbout,
      timeout: 1000
    })
  },
  data () {
    return {
      logo: logo
    }
  },
  methods: {
    closeAbout () {
      this.$store.dispatch('about', false)
    }
  }
}

</script>

<style lang="stylus" scoped>

#about
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background: #F7F7F7
  height: 100vh
  overflow: auto
  z-index: 1005
  header
    text-align: center
    position: relative
    height: 102px
    border-bottom: 1px solid #1257A4
    img.logo
      height: 36px
      margin: 2rem 0
    a.back
      position: absolute
      top: 0
      left: 0
      height: 100%
      padding: 1.6rem 1rem
      border-right: 1px solid #1257A4
      color: #1257A4
  .content
    padding: 3rem 2.5rem 5rem

@media (min-width: 768px)
  #about
    header
      img.logo
        height: 64px
        margin: 1rem 0

</style>
